module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_x-3-Chapter-4"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/section0005"
    }
  }, [_vm._v("Chapter 2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph",
    attrs: {
      "id": "x_41110"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "P_x-4-subhead"
  }, [_c('span', [_vm._v("Johnny, We Hardly Knew Ye or John Kennedy, Cold Warrior")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("“There’s an old saying that victory has a hundred fathers and defeat is an orphan.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("—")]), _vm._v("John Kennedy speaking at a press conference shortly after the Bay of Pigs failure during the first one hundred days of his administration")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("“The government and the people of the United States should wave him good-bye, and see to it that his name is wiped off our national books forever, and he never be allowed to set foot in this country again, dead or alive.”")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("—")]), _vm._v("Part of an article written in the "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Corpus Christi Times")]), _vm._v(" to the news of a series of Americans defecting to the Soviet Union in 1959, in this case specifically Lee Harvey Oswald. The quote sums up Cold War feelings in Texas at the time and things had changed little by 1963, which included Dallas."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n1",
      "id": "CH2n1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("“On November 22, 1963, my uncle, President John F. Kennedy, went to Dallas to condemn as ‘nonsense’ the right wing notion that ‘peace is a sign of weakness.’”")]), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-style": "italic",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n2",
      "id": "CH2n2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("—Robert F. Kennedy, Jr., in a "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Rolling Stone")]), _vm._v(" article published two days before the 50"), _c('span', {
    staticStyle: {
      "font-size": "0.48em",
      "vertical-align": "super"
    }
  }, [_vm._v("th")]), _vm._v(" anniversary of his uncle’s assassination")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The first part this chapter’s title coincides with the title of a 1972 memoir written by Kennedy White House aides Kenny O’Donnell and Dave Powers This title refers to the short time that Kennedy was president and the relatively short time he lived.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("It implies all kinds of things, including the idea that some things didn’t get done and that the country really didn’t have the time to get to know him. Maybe even O’Donnell and Powers didn’t have time to get to know him.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In a sense it seems strange when it comes to something this important, but the country didn’t truly know Kennedy all that well as he campaigned against Richard Nixon in 1960.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Yes, he was a World War II hero and he had been in Congress since the beginning of 1947, first in the House and then the Senate. But all the country really knew was that he would be the youngest man elected president, that he was from the East, that he was Roman Catholic, that he had a rich father with a checkered political past of his own, and that he could be considered liberal, especially in the area of foreign relations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The rest was what the Kennedy and Nixon campaigns told Americans. Some were legends that would be a comfort to the country in the immediate assassination aftermath. Later, as history became a harsher judge, those legends would be attacked and vilified.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Richard Nixon and JFK had been part of the new class of Congressmen in January 1947. The two shook hands and joked with each other after their swearing-in ceremony. Later Kennedy would tell a friend in reference to Nixon, “Listen to this fellow, listen to this fellow. He’s going places.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n3",
      "id": "CH2n3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("“I have always cherished the fact that Jack and")]), _vm._v(" I were friends when we first came to Congress,” Nixon wrote Jacqueline Kennedy on the night of the assassination."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n4",
      "id": "CH2n4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("As his political career progressed faster than Kennedy’s, Nixon established himself as the country’s number-one anti-Communist. Nixon had successfully painted his early Democratic opponents as dangerous leftists. Nixon felt vindicated by the Alger Hiss verdict. Hiss, a State Department official, had been accused of providing sensitive information to the Russians and had lied to Congress about his leftist leanings. It was Nixon who went after Hiss while being a member of the House Un-American Activities Committee.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Nixon won a California Senate seat in 1950 by again painting his opponent, Helen Gahagan Douglas, as a leftist, Communist sympathizer. He said that Douglas was “pink right down to her underwear.” Two years later at the young age of 39, Nixon was picked to be Dwight Eisenhower’s running mate and he assumed the vice presidency in January 1953.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("A little over six years later Nixon had won over")]), _vm._v(" many Americans with his 1959 “kitchen debate” with Soviet Chairman Nikita Khrushchev during a national exhibition in Moscow. Their discussion ranged from the manufacturing of everyday appliances to the threat of nuclear war. By 1960 Nixon’s Cold War credentials were solid and he had demonstrated no hesitance in portraying his political opponents as un-patriotic, Communist dupes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("To go along with Nixon’s political advantages on the national security front, Kennedy knew his party remained on the defensive as being too soft on Communism during the immediate post-World War II period, especially regarding mainland China. The Republicans had accused the Democrats of “losing China” after the Communists under Mao took over the country in 1949. The charge stuck and paved the way for Dwight Eisenhower to win consecutive presidential terms in the fifties. Although he fretted about alienating his liberal base, Kennedy felt he had to move to the right regarding foreign affairs and national security if he was going to win the 1960 election. All he had to do was look at how Adlai Stevenson had been trounced twice by Eisenhower to see that. It was either alienate the Stevenson wing of the party or allow Nixon to win the election in the same manner Eisenhower had over Stevenson.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("So candidate Kennedy thought it was imperative")]), _vm._v(" that he sound every bit the cold warrior his GOP opponent Nixon was and was even admired for. The best way to do that was to hit Nixon in one place where the vice president was vulnerable: Cuba.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Fidel Castro had established himself as Cuba’s dictator on January 1, 1959. Castro soon allied himself with Khrushchev and the Soviet Union. And an already-nervous America was pushed nearer to a dangerous emotional edge. During the campaign, Kennedy exploited that fear by talking about a Communist presence “90 miles off our shore.” So the threat wasn’t in some Asian tundra or in Europe around Berlin. The threat was right off the tip of the Florida Keys. Kennedy’s implication was that the Eisenhower-Nixon Administration didn’t seem concerned, or at least not concerned enough.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("What the country didn’t know in 1960 was that arch anti-Communist Nixon aggressively was pushing Eisenhower to approve already-developing CIA plans to oust Castro from power and help install a political structure in Cuba that was friendly to the United States. Nixon even hoped for an “October surprise” where Eisenhower would take military action to rid Cuba of Castro, and in effect, destroy the Kennedy candidacy in the waning days of the campaign. By late October an un-enthusiastic Ike was not willing to take any dramatic action toward Castro and wouldn’t during the remainder of his presidency. Meanwhile Kennedy pounced and tried to push some distance between Nixon and his conservative base.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("During the last stages of the 1960 campaign and the day before Kennedy’s last debate with Nixon on October 21, the Kennedy campaign put out a white paper advocating for stronger measures regarding Castro and Cuba. It specifically called for direct US aid to overthrow the Communist dictator. Kennedy once more protected his right flank and also put Nixon on the defensive.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“We must attempt to strengthen the non-Batista, anti-Castro in exile and in Cuba itself which offer eventual hope of overthrow of Castro,” the white paper read."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n5",
      "id": "CH2n5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Fulgencio Batista was the corrupt dictator Castro chased out of Cuba in the early days of 1959.)")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“Thus far these fighters for freedom have had virtually no support from our government,” the paper charged as Kennedy tried to portray Eisenhower and Nixon as weak on Communism and on Castro."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n6",
      "id": "CH2n6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("It is customary that once a presidential candidate receives the nomination of his party that he gets briefed on national security matters. Nixon was sure that candidate Kennedy had been told by CIA Director Allen Dulles of ongoing plans regarding Cuba in July. These plans called for a CIA strategy to militarily infiltrate Cuba with Castro foes inside and outside the country. American involvement was supposed to be covert; the CIA wanted this action to appear to be a pure Cuban uprising. An angry Nixon confronted Dulles. Dulles tried to mollify Nixon by telling the vice president that Kennedy had only been told generalities and really had no idea about specifics of any planned military action, covert or not. Nixon was not amused.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("“For the first and only time in the campaign,”")]), _vm._v(" Nixon would write later, “I got mad at Kennedy personally. And my rage was greater because I could do nothing about it.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n7",
      "id": "CH2n7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Because of national security concerns, Nixon believed that he had to counterattack Kennedy so Castro would not be tipped off to any planned military action. Nixon wanted the “covert operation to be protected at all costs.” He would do this even by losing political ground to his opportunistic opponent—no matter how angry Kennedy made him."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n8",
      "id": "CH2n8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("After Kennedy and Nixon made their opening statements in their last debate, Frank Singiser of Mutual News had the first question, which he directed at Nixon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-11"
  }, [_vm._v("“Mr. Vice President,” Singiser began, “I’d like to pin down the difference between the way you would handle Castro’s regime and prevent the establishment of Communist governments in the Western Hemisphere and the way that Senator Kennedy would proceed. Vice President Nixon, in what important aspects do you feel there are differences between you, and why do you believe your policy is better for the peace and security of the United States in the Western Hemisphere?”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.69em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n9",
      "id": "CH2n9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Part of Nixon’s detailed answer follows:")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span', [_vm._v("Nixon Attacks Kennedy’s Plan on Cuba")])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-extract-2"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-extract-2"
  }, [_vm._v("“Our policies are very different. I think that Senator Kennedy’s policies and recommendations for the handling of the Castro regime are probably the most dangerously irresponsible recommendations that he’s made during the course of the campaign. In effect, what Senator Kennedy recommends is that the United States government should give help to the exiles and to those within Cuba who oppose the Castro regime, provided they are anti-Batista. Now let’s see what that means. We have five treaties with Latin America, including the one setting up the Organization of American States in Bogota in 1948, in which we have agreed not to intervene in the internal affairs of another American country-and they as well have agreed to do likewise. The charter of the United Nations,- its preamble, Article I and Article II, also provide that there shall be no intervention by one nation in the internal affairs of another. Now I don’t know what Senator Kennedy suggests when he says that we should help those who oppose the Castro regime, both in Cuba and without. But I do know this: that if we were follow that recommendation, that we would lose all of our friends in Latin America, we would probably be condemned in the United Nations, and we would not accomplish our objective. I know something else. It would be an open invitation for Mr. Khrushchev to come in, to come into Latin America, and to engage us in what would be a civil war, and possibly even worse than that.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.83em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n10",
      "id": "CH2n10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Of course, Nixon knew what the cold warrior Kennedy was suggesting. Suddenly the usually aggressive Nixon sounded weak. It is likely that many debate viewers could have cared less about what was in the United Nations charter (many in Dallas didn’t care about it and there was an anti-United Nations rally in Dallas one month before the assassination) or how the Organization of American States was formed 12 years earlier. Some on the hard right had to be thinking that Nixon sounded like a leftist appeaser advocating a no-win policy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("Although Nixon played the devil’s advocate")]), _vm._v(" role to blunt Kennedy’s right-sided assault, he turned out to be correct on every point. The 1961 action against Cuba failed, an out-of-the-loop Ambassador Adlai Stevenson would be humiliated in the United Nations when he denied “categorically” any American involvement in the action, and a year and a half later, President Kennedy would be confronted with a Soviet nuclear threat in Cuba.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("While Nixon experienced a political gridlock of his own in 1960, by 1961 Kennedy would the find that many, including those within his own administration, would look at him as a paper cold warrior. Kennedy, even though he didn’t want to admit it, had trapped himself by his own campaign rhetoric. He would be fully briefed about CIA plans regarding Cuba shortly after his election.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The Bay of Pigs misadventure seemed to have a momentum of its own.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span', [_vm._v("Kennedy Delivers His Cold Warrior Address")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The truth was that the country still didn’t know who it elected as Kennedy named his cabinet and readied himself to take office. Many looked anxiously to his inaugural address hoping it would give an indication that Kennedy was up to holding the most powerful office in the world. With the speech’s sterling rhetoric as crafted by Ted Sorenson and Kennedy’s excellent delivery, many were reassured that the United States had a capable leader in the White House.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("For cold warriors,")]), _vm._v(" the following passages delivered by Kennedy had to be especially reassuring. First with a general statement:")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("—“Let every nation know, whether it wishes us well or ill, that we shall pay any price, bear any burden, meet any hardship, support any friend, oppose any foe, in order to assure the survival and the success of liberty.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("Then a campaign-like jab at Castro:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("—“Let all our neighbors know that we shall join them to oppose aggression or subversion anywhere in the Americas. And let every other power know that this hemisphere intends to remain the master of its own house.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("A strong defense commitment, after rousing applause:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("—“We dare not tempt them with weakness. For only when our arms are sufficient beyond doubt can we be certain beyond doubt that they will never be employed.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("Finally, near the end, some dramatic words:")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("—“In the long history of the world, only a few generations have been granted the role of defending the nation in its hours of maximum danger. I do not shrink from this responsibility—I welcome it.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image8.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("A stirring address with a sense of bravado. Navy admiral and cold warrior Arleigh Burke was moved by the oratory.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“I have never heard a better speech,” Burke would say. “It is the best statement of policies in which I believe that I have ever heard. I was extremely proud that day.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n11",
      "id": "CH2n11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("But then there were some words and phrases")]), _vm._v(" that didn’t have the tone of a militant anti-Communist and ardent cold warrior.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“So let us begin anew, remembering on both sides that civility is not a sign of weakness and sincerity is always subject to proof. Let us never negotiate out of fear. But let us never fear to negotiate.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“Let both sides join in creating a new endeavor, not a new balance of power, but a new world of law, where the strong are just and the weak secure and the peace preserved.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“And to remember that, in the past, those who foolishly sought power by riding the back of the tiger ended up inside.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“Let both sides, for the first time, formulate serious and precise proposals for the inspection and control of arms-and bring the absolute power to destroy other nations under the control of all nations.”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("That last statement drew only a smattering of applause, almost a nervous type of applause. Some hard liners had to be wondering what Kennedy meant by provision of inspection and control of arms. The power to destroy nations under the control of all nations? Would this include Cuba? The Soviet Union?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("And the warning about ending up inside the tiger? Was that a warning to the Soviet Union or to his fellow countrymen? What good was it to have power if the president of the United States wasn’t willing to use it? Was this the cold warrior of the campaign that hinted in using military force to oust Fidel Castro? In some ways, he didn’t sound like it.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The country still didn’t know John Kennedy, at least not totally.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image9.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The Bay of Pigs operation won’t de detailed here. Safe to say there have been two sides that have debated Kennedy’s action regarding that CIA operation for the past fifty-plus years. Kennedy supporters have maintained that the CIA lied to him and tried to manipulate him into a full-scale invasion backed by the American military, when he, Kennedy, had said all along that could be no overt American military involvement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("His detractors counter that the new president acted in a defensive manner, and refused to utilize American power, and abandoned a desperate group of people trying to take back their country.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("Regardless, the Bay of Pigs operation has been repeatedly")]), _vm._v(" called a fiasco, and it handed Kennedy a stunning political defeat. In the anti-Castro Cuban brigade, 114 were killed and 1,189 were taken prisoner.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In the short run, Kennedy benefited from the disaster politically. When he took responsibility for the disaster and expressed his own empathy for the Cuban exiles, his standing in opinion polls went up. An early May poll showed his approval rate at 65 percent."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n12",
      "id": "CH2n12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("However, there was still plenty of domestic backlash to the international embarrassment.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Two small demonstrations in California protested what was thought as American aggression. Roughly one thousand students staged a protest at Berkeley. A week later an estimated two thousand students gathered at Union Square in San Francisco to make the same statement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("While Kennedy had alienated a small portion of the left, what about the cold warrior right that he had been so concerned about during the 1960 campaign? It was the part of the country that had worried he didn’t fully understand the Communist threat. It was the part of the country that he had appealed to when talking about increasing aid to anti-Castro Cubans both inside and outside of the country. It was the part of the country he lectured about communism existing ninety miles off our shore.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“And if Kennedy thought abandoning our Cuban allies would save him inconvenience, he was dead wrong. The bungled invasion cemented Castro’s ties to the USSR, setting the stage for the nuclear confrontation over the missiles on the island the next year-a crisis fueled by Soviet Premier Nikita Khrushchev’s belief that the president who panicked at the Bay of Pigs could be bluffed and rolled.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n13",
      "id": "CH2n13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The above statement was written over fifty years after the event by Arthur Herman. It no doubt reflected the feeling of hardliners toward the new president in 1961. As far as Herman was concerned, the Bay of Pigs and consequent foreign policies that failed afterward only demonstrated that the Democratic Party or any leader who followed in their path could not be trusted with national security matters. He believed this was a philosophy of “halfway measures” that only lead to defeat. Kennedy and the Democrats would remain on the defensive regarding national security issues for decades to come. Only the killing of Osama Bin Laden by the order of President Obama changed that dynamic some.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-4__And__Centre_Alignment"
  }, [_c('span', [_c('img', {
    staticStyle: {
      "max-width": "100%",
      "max-height": "100%"
    },
    attrs: {
      "alt": "",
      "src": "image10.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("The Cuban Missile Crisis. The handling of the crisis is looked upon as the crowning achievement of the shortened Kennedy administration. In the 2000 movie "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Thirteen Days")]), _vm._v(", actor Bruce Greenwood portrays Kennedy as a president shaken by the presence of Soviet missiles in Cuba, a man who sometimes allowed himself to fall into self-pity and a leader who made cavalier mistakes. However, through it all, Greenwood’s JFK is resolute, thoughtful, willing to hear all sides to an important issue, and not afraid to negotiate to get the country out of a crisis. At the movie’s end, the movie-goers hear the real Kennedy delivering his American University speech of June 1963 reminding us that we are all mortal.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("And from appearances, Kennedy seemed to")]), _vm._v(" regain his prominence as a cold warrior. At the conclusion of the crisis, it appeared that Khrushchev had backed down from a no-nonsense Kennedy. As the president had said in his inaugural speech, this hemisphere intended to be master of its own house.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Of course, things were more complicated and that was not the way it happened. Khrushchev had to answer to hard-liners of his own, and he had to be given something. Kennedy obliged with a pledge not to invade Cuba (a direct contradiction to his brazen 1960 campaign talk) and the eventual removal of United States missiles from Turkey. Some within Kennedy’s own administration thought the resolution to the Cuba Crisis was an American setback even though there had been plans to remove obsolete missiles from Turkey for some time.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“It’s the greatest defeat in our history,” General Curtis LeMay yelled at Kennedy at the conclusion of the crisis. “We should invade today.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n14",
      "id": "CH2n14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“We had a chance to throw the Communists out of Cuba,” LeMay later said. “But the Administration was scared to death [the Russians] might shoot a missile at us.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n15",
      "id": "CH2n15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Daniel Ellsberg of Pentagon Papers fame was a defense analyst during the aftermath of the missile crisis. He would later recall to author David Talbot the awful mood of the military and the overwhelming animosity toward President Kennedy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“"), _c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("There was virtually a coup atmosphere in Pentagon circles,” ")]), _vm._v("Ellsberg said. “Not that I had the fear there was about to be a coup—I thought it was a mood of hatred and rage. The atmosphere was poisonous, poisonous.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n16",
      "id": "CH2n16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Some elements of the military thought Kennedy had missed his big chance to take dramatic action in Cuba, and some in the CIA were despondent over the pledge not to invade the island. Still, there had been a shift in the public psyche. Kennedy’s speech writer Ted Sorenson believed that Americans no longer thought war with the Soviet Union was inevitable. Writer Susan Roy, who would chronicle the American dread to the point of building fallout shelters, also saw a dramatic change. Some still feared a nuclear attack, but they weren’t going to go running to shelters for safety, she wrote. Whatever happened, happened. The country had calmed down.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In June 1967, Amitai Etzioni of Columbia University wrote an article entitled “The"), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }), _vm._v("Kennedy Experiment,” which was published in the"), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v(" Western Political Quarterly")]), _vm._v(". The article dealt with two issues in detail: one was the changing mood of America regarding the Cold War, and the other was how President Kennedy altered his diplomatic approach to the Soviet Union.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Etzioni wrote: “The establishment of a Communist government in Cuba, Soviet successes in space, the fiasco of the 1961 Bay of Pigs Invasion, and the positioning of Soviet missiles in Cuba in 1962 all further deepened American frustration. While initially the 1962 blockade raised many fears, once it proved not to lead to war and to yield a Soviet retreat, it became the first American victory in a long time. While the blockade’s successes were widely viewed as supporting the ‘tough’ line, suggesting that power politics could be used in the nuclear age, the psychological effect was in the opposite direction, one of cathartic release.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n17",
      "id": "CH2n17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In essence, the result of the Cuban Missile Crisis result didn’t bring about a harder line on the Cold War, as Kennedy’s generals and the CIA had wanted. Etzioni instead concluded that the crisis “increased the Americans’ emotional willingness to accept arms control negotiations with the Soviet Union.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n18",
      "id": "CH2n18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("Presidents follow as much as they lead.")]), _vm._v(" Kennedy had to sense a change in the American electorate as indicated in the earlier Sorenson statement. Kennedy was always conscious of politics, even during the Cuban Missile Crisis, and he was not going to propose a major policy change without thinking there was at least some support for it. So the timing and tone of Kennedy’s June 1963 American University speech was not surprising.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Etzioni summarized what he thought was a political experiment conducted by JFK in changing United States policy as it applied to the Cold War.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“The Kennedy experiment can be viewed as a test of a moderate version of the psychological theory that seeks to use symbolic gestures as unilateral initiatives to reduce tension to get at other factors, leading to multi-lateral negotiations.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.68em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n19",
      "id": "CH2n19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Etzioni wrote that the first unilateral move to ease tension was Kennedy’s announcement in his American University speech, that the United States was ending its nuclear tests in the atmosphere. That policy would stay in place until another country resumed its atmospheric testing, Kennedy said. Etzioni added that the United States could end its testing for various reasons, and the new policy wasn’t compromising the country strategically in any military or nuclear sense. So Kennedy’s gesture was psychological in nature and a way to break the ice with the Soviets for more serious negotiations.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Khrushchev responded in kind, according to Etzioni. Khrushchev reacted warmly to Kennedy’s address five days later, also saying that nuclear war was not inevitable. Khrushchev then announced that he was halting the construction of Soviet strategic bombers. Etzioni maintained this was a psychological ploy since these bombers were to be phased out soon anyway. However, the Russian response to the Kennedy speech was warm. The Soviet Union turned off its radio jammers to the Voice of America recording of the speech, allowing the Russian people to listen to it in its entirety."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n20",
      "id": "CH2n20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _c('span', {
    staticStyle: {
      "font-size": "0.48em",
      "vertical-align": "super"
    }
  }), _vm._v("The Cold War had thawed a little.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Negotiations for the nuclear test ban treaty began in July. Etzioni quoted a Lou Harris opinion poll showing that 52 percent of the American public supported the treaty. By the time it was ratified in September, that figure stood at 81 percent. Meanwhile, Kennedy approved a $250 million sale of wheat to the Soviet Union in October.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("So the country and Kennedy had come a long way since the 1960 campaign, when it seemed only a tough and hard line could be used against the Soviet Union or its surrogates. For some the hard line included a preemptive nuclear attack on the Soviet Union. Rejecting doomsday scenarios, Kennedy was no longer a candidate; he was a statesman.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("“The Cold Warrior John F. Kennedy was turning,” James Douglas wrote in his book "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("JFK and the Unspeakable")]), _vm._v(", “in the root biblical sense of the word ‘turning’—teshuvah in the Hebrew Scriptures, metonoia in the Greek, ‘repentance’ in English.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In the Cuban Missile Crisis John Kennedy as president of the United States had begun to turn away from, to repent from, his own complicity with the worst of US imperialism—its willingness to destroy the world in order to ‘save it’ from Communism.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n21",
      "id": "CH2n21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span')]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-15"
  }, [_vm._v("Dallas News Ad Questions Kennedy on")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_x-5-subhead-2"
  }, [_c('span', [_c('span', {
    staticClass: "C_span_char-style-override-15"
  }, [_vm._v("Nov. 22, 1963")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Not all thought Kennedy was a hero or statesman of any kind. In the "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Dallas Morning")]), _vm._v(" "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("News ")]), _vm._v("advertisement on November 22, 1963, the “American Fact-Finding Committee” was not interested in any political experiment. It asked the president the following questions:")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-extract-2"
  }, [_vm._v("“Why have you approved the sale of wheat and corn to our enemies when you know the Communist soldiers ‘travel on their stomachs’ just as ours do? Communist soldiers are daily wounding and or killing American soldiers in South Vietnam.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-extract-2"
  }, [_vm._v("“Why did you host and entertain Tito—Moscow’s Trojan Horse—just a short time after our sworn enemy, Khrushchev, embraced the Yugoslav dictator as a great hero and leader of Communism?”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-11"
  }, [_vm._v("The ad was harsh. "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("News")]), _vm._v(" publisher Ted Dealey, defended the ad, saying it pretty much reflected the newspaper’s editorial policy."), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.69em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n22",
      "id": "CH2n22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Bernard Weissman, who signed the advertisement, stated to the Warren Commission that he received positive reaction to the ad even after the assassination. (The total response was rather small. Weismann told the commission that he received a total response of between fifty and sixty letters to the post office box listed on the ad.)"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.75em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n23",
      "id": "CH2n23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Dallas residents—then and now—worry about the political atmosphere in the city the day Kennedy was killed. Did an ultra-conservative movement create an atmosphere where an assassination was more likely? A group that had little toleration for anything that Kennedy did?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Weissman told the commission that he was relieved that Oswald, an alleged Marxist, had shot the president. He had feared that he and his ad would be blamed or connected to the crime in some way. A person like Oswald, detested by Texans as stated in the Corpus Christi article, exonerated both Weissman and the community.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph_para-style-override-11"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("But was Oswald the killer and was he that deranged?")]), _vm._v(" If Kennedy was negotiating treaties with the Soviet Union and basically laying off Cuba, why would a Communist or at least a Communist sympathizer want to pull off the crime? And what would have the lefty Oswald thought if he knew that Kennedy was making secret diplomatic overtures to Castro, overtures that were happening as Kennedy travelled to Texas? To take things further, had Oswald really had been a defector?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In his book, "), _c('span', {
    staticClass: "C_span_char-style-override-10"
  }, [_vm._v("Oswald and the CIA")]), _vm._v(", author John Newman cited a memo that John McVickar wrote in November 1963 regarding Oswald’s Soviet defection. McVickar worked in the American Embassy in Moscow at the time Oswald was defecting.")]), _vm._v(" "), _c('p', {
    staticClass: "P_x-e-extract-2"
  }, [_vm._v("“It seemed that could also have been that he had been taught to say things which he didn’t really understand. In short it seemed to me that there was a possibility that he had been in contact with others before or during his Marine Corps tour who had guided him and encouraged him in his actions.”"), _c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "0.83em",
      "vertical-align": "super"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/section0028#nChapter2n24",
      "id": "CH2n24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("In other words, Oswald may have not been a real defector but a part of a series of Americans trying to infiltrate Russian society. Unlike the United States, the Soviet Union was a closed country and it was difficult to obtain information that went beyond the usual propaganda. One way to counter that was to have Americans infiltrate the country and see things firsthand.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Weissman and others have said that they were relieved when Oswald was arrested on November 22, 1963. He and the city elite didn’t want any connection with an extreme right-wing element of Dallas. Meanwhile, Oswald the Russian defector and Oswald the Castro lover was the perfect foil. Violence had come from a Communist—not some misguided patriot or anyone who could have been connected to other zealous political actions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Consider this: if Oswald had been sent to the Soviet Union on a mission from the American government, Oswald had been, in reality, an anti-Communist—a cold warrior. That complicated things in that Oswald would have fit in with parts of right-wing Dallas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_c('span', {
    staticClass: "C_span_char-style-override-11"
  }, [_vm._v("But if Oswald was the left-wing nut")]), _vm._v(" the Warren Commission said he was, that indeed helped exonerate Dallas. Oswald was not a product of Dallas, and no local political atmosphere was at any fault.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("Instead it was the very political system that the city had been warning Kennedy and the country about, only no one appeared to be listening. They were too busy conducting political experiments and negotiating treaties.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("And so Kennedy would have been killed by a loner and Communist dupe. It seemed as if Kennedy’s new policy of co-existence, seen by many in Dallas as appeasement, had led to his own destruction.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Basic-Paragraph"
  }, [_vm._v("How could Dallas be blamed for John Kennedy turning his back on his own cold warrior campaign talk?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3647a882","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0010.vue
// module id = 84
// module chunks = 0